import {
    Flex, Box, SimpleGrid, Image,
} from "@chakra-ui/react";
import React from "react";
import { StyleSheet, css } from "aphrodite";
import { useSelector } from "react-redux";

function NextconMembers () {
    
    const isMobile = useSelector(state=> state.windowSize.isMobile);

    const ColNum = isMobile ? 2 : 4;
    const ColNum_ad = 2/*isMobile ? 2 : 3;*/

    return(
        <>
        <Box className={css(styles.head)}>
            <Flex className={css(styles.container)}>
                NEXTCON Lab & SCVIC CENTRE Director 
            </Flex>
            <SimpleGrid columns={1} spacing={10} textAlign="center" marginTop={5} marginBottom={5}>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-BurakKantarci_Profile.jpg" alt="Burak Kantarci" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Prof. Burak Kantarci
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Program Director
                    </Flex>
                </Box>
            </SimpleGrid>
            <hr />
            <Flex className={css(styles.container)}>
                Lab Coordination and Administration 
            </Flex>
            <SimpleGrid
                columns={ColNum_ad}
                spacing={6}
                px={{ base: 4, md: 10 }}
                maxWidth={{ base: "100%", md: "1000px" }}
                margin="auto"
                textAlign="center"
                marginTop={5}
                marginBottom={5}
            >
                
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Iman.png" alt="Iman Amini" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Dr. Iman Amini
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Research Associate and DND project p.m.
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Elis.jpg" alt="Iraz Eliz Deniz" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Iraz Eliz Deniz
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Project Coordinator <br/> &nbsp;
                    </Flex>
                </Box>
            </SimpleGrid>
            <hr />
            <Flex className={css(styles.container)}>
                Postdoctoral Researchers 
            </Flex>
            <SimpleGrid
                columns={ColNum}
                spacing={6}
                px={{ base: 4, md: 10 }}
                maxWidth={{ base: "100%", md: "1200px" }}
                margin="auto"
                textAlign="center"
                marginTop={5}
                marginBottom={5}
            >
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="Nilesh_uOttawa.jpg" alt="Nilesh Chakraborty" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Dr. Nilesh Chakraborty <br/> &nbsp; <br/> &nbsp;
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="sudipta_uOttawa.jpg" alt="Sudipta Acharya" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Dr. Sudipta Acharya <br/> &nbsp; <br/> &nbsp;
                    </Flex>
                </Box>

                
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="Poonam New.png" alt="Poonam Lohan" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Dr. Poonam Lohan <br/> &nbsp; <br/> &nbsp;
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="Photo_Sachin.jpg" alt="Sachin Trankatwar" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Dr. Sachin Trankatwar <br/> &nbsp; <br/> &nbsp;
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                    </Flex>
                </Box>
                {/*
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="GwanggilJeon.png" alt="Gwanggil Jeon" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Dr. Gwanggil Jeon
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        (Visiting Professor)
                    </Flex>
                </Box>
                */}

            </SimpleGrid>
            <hr />
            <Flex className={css(styles.container)}>
                Ph.D Students 
            </Flex>
            <SimpleGrid columns={ColNum} spacing={8} margin="auto" textAlign="center" marginTop={8} marginBottom={5} maxWidth={{ base: "100%", md: "1200px" }} >
                {/*
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Ahmed.jpg" alt="Ahmed Omara" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Ahmed Omara
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Ph.D - Elec. and Comp. Eng <br/> &nbsp;
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Bin.png" alt="Bin Xiao" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Bin Xiao
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Ph.D in Computer Science <br/> &nbsp;
                    </Flex>
                </Box>
                */}
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Didem.jpg" alt="Didem Cicek Simsek" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Didem Cicek Simsek
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Ph.D - Digital Transformation and Innovation
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Samhita.jpg" alt="Samhita Kuili" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Samhita Kuili
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Ph.D - Elec. and Comp. Eng
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Arda.png" alt="Murat Arda Onsu" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Murat Arda Onsu
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Ph.D - Computer Science
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Parissa.jpg" alt="parisa fard moshiri" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Parisa Fard Moshiri
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Ph.D - Elec. and Comp. Eng
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Ghazal.png" alt="Ghazal Asemian" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Ghazal Asemian
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Ph.D - Elec. and Comp. Eng
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Xuli.jpg" alt="Xuli Cai" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Xuli Cai
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Ph.D - Computer Science
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Lansu.jpg" alt="Lansu Dai" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Lansu Dai
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                       Ph.D - Computer Science
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Hanqing.png" alt="Hanqing Zhou" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Hanqing Zhou
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Ph.D - Computer Science 
                    </Flex>
                </Box>

                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="unknown.png" alt="profile" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Vojtech Halenka
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Visiting Ph.D Student 
                    </Flex>
                </Box>
                </SimpleGrid>

                <Flex className={css(styles.container)}>
                    Master's Students 
                </Flex>
                <SimpleGrid columns={ColNum} spacing={8} margin="auto" textAlign="center" marginTop={8} marginBottom={5} maxWidth={{ base: "100%", md: "1200px" }} >
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Oliver.jpg" alt="Oliver Benning" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Oliver Benning
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Master in Computer Science
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-ZHANGYueteng.jpg" alt="Yueteng Zhang" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Yueteng Zhang
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Master in Elec. and Comp. Eng  
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="NEXTCON-Arild.jpg" alt="Arild Yonkeu Tchana" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Arild Yonkeu Tchana
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Master in Computer Science
                    </Flex>
                </Box>
                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="zhu.png" alt="Xinyu Zhu" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Xinyu Zhu
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                    Master in Elec. and Comp. Eng
                    </Flex>
                </Box>

                <Box justifyContent="center" alignContent="center">
                    <Flex justifyContent="center">
                        <Image src="Harsh Patel.jpg" alt="Harsh PAtel'" className={css(styles.images)} />
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.names)}>
                        Harsh Patel
                    </Flex>
                    <Flex flexDirection="column" className={css(styles.title)}>
                        Master in Elec. and Comp. Eng
                    </Flex>
                </Box>
                

            </SimpleGrid>
        </Box>
        </>
    )
};

const styles = StyleSheet.create({
    head: {
        maxWidth: '100vw',
        marginTop: 0
    },
    parent: {
        maxWidth: '100vw',
        textAlign: 'center'
    },
    container: {
        maxWidth: '100%',
        justifyContent: 'center',
        fontSize: 30,
        margin: '1%',
        fontWeight: 'bolder',
        textShadow: '1px 1px gray',
        textAlign: 'center'
    },
    textbox: {
        margin: '2%',
        marginTop: '0%',
        textAlign: 'center',
        fontSize: 18,
        justifyContent: 'center',
        alignContent: 'center'
    },
    names: {
        fontWeight: 'bold',
        fontSize: 20
    },
    title: {
        fontSize: 18,
    },
    images: {
        width: '200px',
        height: '200px',
        fit: "fit",
        borderRadius: "100%"
    },
    mobileImage: {
        width: "70%",
        borderRadius: "80%"
    }
})

export default NextconMembers